// @flow
import * as React from "react";
import { Segment } from "semantic-ui-react";

import TopBar from "../TopBar";
import Footer from "../Footer";

type Props = {
  children: React.Node,
};

const ContentStyles = {
  minHeight: "50vh",
  padding: "0.5rem 0",
};

const Template = (props: Props) => {
  const { children } = props;

  return (
    <>
      <TopBar>
        <Segment basic style={ContentStyles}>
          {children}
        </Segment>
        <Footer />
      </TopBar>
    </>
  );
};

export default Template;
